import { useEffect, useState } from "react";
import { useTheme } from "next-themes";

export const THEME_OVERRIDE_KEY = "catclaw-theme-override";

/** 根据客户端本地时间返回 light（06:00–17:59）或 dark（18:00–05:59）。 */
export function getThemeByLocalTime() {
  const hour = new Date().getHours();
  return hour >= 6 && hour < 18 ? "light" : "dark";
}

/** 自动按本地时间切换 light/dark；若用户手动点击过主题按钮，则尊重手动选择。 */
export function useTimeBasedTheme() {
  const { setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (!mounted) return;

    const override = localStorage.getItem(THEME_OVERRIDE_KEY);
    if (override === "light" || override === "dark") {
      setTheme(override);
      return;
    }

    const apply = () => setTheme(getThemeByLocalTime());
    apply();
    const id = setInterval(apply, 60_000);
    return () => clearInterval(id);
  }, [mounted, setTheme]);
}
